import { render, staticRenderFns } from "./CanvasContextMenu.vue?vue&type=template&id=1e4460be&scoped=true"
import script from "./CanvasContextMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./CanvasContextMenu.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CanvasContextMenu.vue?vue&type=style&index=0&id=1e4460be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4460be",
  null
  
)

export default component.exports